import React from 'react';
import ObjectName from './objectName';
import ObjectProperties from './objectProperties';

export default function ObjectTab({
  selectedModel,
  selectedModelProps,
  dispatchChangeModels,
  setSelectedModelProps,
}) {
  const threeObj = selectedModel.props.asset.ref.current;
  return (
    <>
      <ObjectName
        assetType={selectedModel.props.asset.type}
        selectedModel={selectedModel}
      />

      <ObjectProperties
        assetType={selectedModel.props.asset.type}
        selectedModel={selectedModel}
        selectedModelProps={selectedModelProps}
        dispatchChangeModels={dispatchChangeModels}
        setSelectedModelProps={setSelectedModelProps}
      />
    </>
  );
}
